import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  auditNameLabel: {
    description: 'Label for the Audit Name field in the audit form modal',
    defaultMessage: 'Audit Name',
    id: '/5zmWP',
  },
  dueDateLabel: {
    description: 'Label for the Due Date field in the audit form modal',
    defaultMessage: 'Due Date',
    id: 'Vy9vIY',
  },
  assignToLabel: {
    description: 'Label for the Assign To dropdown in the audit form modal',
    defaultMessage: 'Assign To',
    id: '4aUaUE',
  },
  assignToPlaceholder: {
    description: 'Placeholder text for the Assign To dropdown in the audit form modal',
    defaultMessage: 'Select a user',
    id: 'nGsAqh',
  },
  unassignedOption: {
    description: 'Option in the Assign To dropdown to leave the audit unassigned',
    defaultMessage: 'Unassigned',
    id: 'lRNwK0',
  },
  notesLabel: {
    description: 'Label for the Notes field in the audit form modal',
    defaultMessage: 'Notes',
    id: 'HqHwOm',
  },
  unknownUserOption: {
    description: 'Display text when an audit is assigned to a user who is no longer in the users list',
    defaultMessage: 'Unknown user',
    id: 'KJEl8T',
  },
});
